/* SILNTPLAY — sl-core.js. Global behaviour for rebuilt templates only:
   the single reveal, and the header menu drawer. No dependencies. */
(function () {
  'use strict';

  /* Reveal: .sl-reveal fades in once. Anything already on screen at load is
     shown immediately (no flash on the hero). A scroll/resize safety net
     reveals anything the observer missed, so content is never left hidden. */
  function initReveal(root) {
    var items = Array.prototype.slice.call((root || document).querySelectorAll('.sl-reveal:not(.is-in)'));
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    items.forEach(function (el) {
      if (el.getBoundingClientRect().top < window.innerHeight) el.classList.add('is-in');
      else io.observe(el);
    });
    var pending = false;
    function sweep() {
      pending = false;
      document.querySelectorAll('.sl-reveal:not(.is-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < window.innerHeight * 1.1) el.classList.add('is-in');
      });
    }
    function schedule() { if (!pending) { pending = true; window.requestAnimationFrame(sweep); } }
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', schedule);
  }

  /* Header menu drawer (mobile). <details data-sl-menu>: lock scroll while open,
     close on Escape and on link tap, return focus to the toggle. */
  function initMenu() {
    document.querySelectorAll('details[data-sl-menu]').forEach(function (menu) {
      if (menu.dataset.slInit) return;
      menu.dataset.slInit = '1';
      var summary = menu.querySelector('summary');
      menu.addEventListener('toggle', function () {
        document.documentElement.classList.toggle('sl-menu-open', menu.open);
        /* The panel starts below the announcement bar too, so size it to what is left of the screen. */
        var panel = menu.querySelector('.sl-menu__panel');
        if (menu.open && panel) menu.style.setProperty('--sl-menu-top', Math.max(0, panel.getBoundingClientRect().top) + 'px');
        if (summary) summary.setAttribute('aria-expanded', String(menu.open));
      });
      menu.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && menu.open) { menu.open = false; if (summary) summary.focus(); }
      });
      menu.querySelectorAll('a').forEach(function (link) {
        link.addEventListener('click', function () { menu.open = false; });
      });
    });
  }

  function init(root) { initReveal(root); initMenu(); }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
